import React, {Component} from "react";
// import * as rainMap from "./img/map.png"; // We can't use this on shoptet
// import "bootstrap/dist/css/bootstrap.css";
import fetchProducts from "./helpers/fetchExternalProducts";
import ColorSelector from './components/ColorSelector'
import CalculatorInput from "./components/CalculatorInput";
// import CalculatorResults from "./components/CalculatorResults";
import SuggestedProducts from "./components/SuggestedProducts";
import AvailableVolumeFromRain from "./components/calcResults/AvailableVolumeFromRain";
import NeededVolume from './components/calcResults/NeededVolume';
import CalcSummary from './components/calcResults/CalcSummary';
//import ContactForm from "./components/ContactForm";

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // Inputs
      rainVolume: "",
      roofArea: "",
      dwellersCount: "",
      gardenArea: "",
      selectedLevel : null,

      // Inputs blurred at least once
      touched: {
        rainVolume: false,
        roofArea: false,
        dwellersCount: false,
        gardenArea: false,
      },

      //Inputs and form validation
      rainVolumeValid: false,
      roofAreaValid: false,
      dwellersCountValid: true,
      gardenAreaValid: true,
      formValid: false,

      // Calculated
      availableVolume: null,
      harvestedVolume: 0,
      suggestedCistern: null,
      suggestedTanksAboveGround: [],
      suggestedTanksUnderGround: [],
      suggestedSets: [],

      // All fetched sets
      allUnderGround: null,
      allAboveGround: null,
      allSets: null,

      // Problem with xml
      formErrorMessage: ''
    };

    this.fillStateWithProducts = this.fillStateWithProducts.bind(this);
    this.inputChanged = this.inputChanged.bind(this);
    this.findTanksInProducts = this.findTanksInProducts.bind(this);
    this.inputBlurred = this.inputBlurred.bind(this);
    this.handleFormError = this.handleFormError.bind(this);
    this.colorLevelChanged = this.colorLevelChanged.bind(this);

    this.availableVolume = null;
    this.neededVolume = null;
    this.suggestedSets = [];
    this.suggestedTanksAboveGround = [];
    this.suggestedTanksUnderGround = [];
  }

  componentDidMount(){

    fetchProducts(this.fillStateWithProducts, this.handleFormError);

  }

  fillStateWithProducts(products, category){

    switch(category){
      case 'podzemni':
        this.setState({ allUnderGround: products });
        break;
      case 'nadzemni':
        this.setState({ allAboveGround: products });
        break;
      case 'sestavy':
        this.setState({ allSets: products });
        break;
      default:
        return;
    }

  }

  inputChanged(event, name) {
    const value = event.target.value;
    this.setState({
      [name]: value,
      harvestedVolume: 0,
      calculationResults: null,
      suggestedTanksAboveGround: [],
      suggestedTanksUnderGround: [],
      suggestedSets: [],
      }, () => {
      this.inputValidate(name, value);
    });
  }

  colorLevelChanged(rainVolume) {
    this.setState({ rainVolume, rainVolumeValid: true, touched: {...this.state.touched, rainVolume: true} });
  }

  inputBlurred(name) {
    const touched = { ...this.state.touched, [name]: true}
    this.setState({ touched });
  }

  inputValidate(name, value) {
    let fieldVadilationErrors = this.state.formErrors;
    let rainVolumeValid = this.state.rainVolumeValid;
    let roofAreaValid = this.state.roofAreaValid;
    let dwellersCountValid = this.state.dwellersCountValid;
    let gardenAreaValid = this.state.gardenAreaValid;
    
    switch (name) {
      case "rainVolume":
        // Johnny: Will accept 400 because 400 or 401 doesn't make a difference.
        rainVolumeValid = value >= 400 && value <= 1400;
        break;

      case "roofArea":
        roofAreaValid = value > 0;
        break;

      case "dwellersCount":
        dwellersCountValid = value === '' || value >= 0;
        break;

      case "gardenArea":
        gardenAreaValid = value === '' || value >= 0;
        break;

      default:
        return value >= 0;
    }

    this.setState(
      {
        formErrors: fieldVadilationErrors,
        rainVolumeValid,
        roofAreaValid,
        dwellersCountValid,
        gardenAreaValid
      },
      this.validateForm
    );
  }

  validateForm() {
    this.setState({
      formValid: this.state.rainVolumeValid && this.state.roofAreaValid && this.state.dwellersCountValid && this.state.gardenAreaValid
    });
  }

  findTanksInProductsStart = () => {
    this.findTanksInProducts(this.state.allAboveGround, 'nadzemni');
    this.findTanksInProducts(this.state.allUnderGround, 'podzemni');
    this.findTanksInProducts(this.state.allSets, 'sestavy');
  }

  findTanksInProducts = (products, category) => {

    if(!this.availableVolume || !this.neededVolume){
      return;
    }

    const suggestedCisternLiters = Math.min(this.availableVolume, this.neededVolume)*1000;
    
    let volumesNormalized = [];

    products.forEach(product => {
      if (product["TEXT_PROPERTIES"] && product['VISIBILITY'][0] === 'visible') {
        const volumeProperty = this.getVolumeProperty(product["TEXT_PROPERTIES"]);

        if (volumeProperty) {
          const volumeParsed = parseFloat(volumeProperty.replace(/\D.*/g, ""));
          if(volumeParsed >= suggestedCisternLiters){
            volumesNormalized.push({
              product,
              volume: volumeParsed,
              volumeDiff: volumeParsed - suggestedCisternLiters
            });
          }
        }
      }
    });

    volumesNormalized.sort((a, b) => {
      return a.volumeDiff - b.volumeDiff;
    });
    
    const suggestedProducts = volumesNormalized.splice(0, 3).map(item => item.product);

    if (category === 'sestavy') {
      this.suggestedSets = suggestedProducts;
    } else if (category === 'nadzemni'){
      this.suggestedTanksAboveGround = suggestedProducts;
    } else if (category === 'podzemni'){
      this.suggestedTanksUnderGround = suggestedProducts;
    }
  };

  getVolumeProperty(properties) {
    let ret = false;
    properties.forEach(property => {
      property.TEXT_PROPERTY.forEach(subproperty => {
        if (subproperty.NAME.includes('Objem')) {
          ret = subproperty.VALUE[0];
        }
      })
    });

    return ret;
  }

  setAvailableVolume = (availableVolume) => {
    if(availableVolume){
      this.availableVolume = availableVolume;
      this.findTanksInProductsStart();
    } else {
      this.availableVolume = null;
    } 
  }

  setNeededVolume = (neededVolume) => {
    if(neededVolume){
      this.neededVolume = neededVolume;
      this.findTanksInProductsStart();
    } else {
      this.neededVolume = null;
    }
  }

  handleFormError(error){
    this.setState({ formErrorMessage: error.message })
  }


  

  render() {
    return (
      <div className="App">
        <div id="calculator-inputs">
          <ColorSelector 
            label = "Vyberte oblast podle barvy nebo vložte úhrn srážek ručně"
            selectedLevel = {this.state.selectedLevel}
            onChangeHandler = {this.colorLevelChanged}
          />
          <CalculatorInput
            label="Srážkový úhrn dle mapy (mm) *"
            paramId={"rainVolume"}
            value={this.state.rainVolume}
            onChangeHandler={this.inputChanged}
            onBlurHandler={this.inputBlurred}
            touched={this.state.touched.rainVolume}
            errorClass={this.state.rainVolumeValid}
            errorText={"Nastavte srážkový úrhn podle mapy v rozsahu 401 mm - 1400 mm."}
            valid={this.state.rainVolumeValid}
            placeholder={"401 až 1400 mm"}
          />
          <CalculatorInput
            label="Plocha střechy, půdorysný průmět (m²)"
            paramId={"roofArea"}
            value={this.state.roofArea}
            onChangeHandler={this.inputChanged}
            onBlurHandler={this.inputBlurred}
            touched={this.state.touched.roofArea}
            errorClass={this.state.roofAreaValid}
            errorText={"Nastavte plochu střechy větší, než 0 m²"}
            valid={this.state.roofAreaValid}
            placeholder={"Plocha střechy v metrech čtverečních..."}
          />
          <AvailableVolumeFromRain
            valid={this.state.rainVolumeValid && this.state.roofAreaValid}
            rainVolume={this.state.rainVolume}
            roofArea={this.state.roofArea}
            roofAngle={this.state.roofAngle}
            otherAreas={this.state.otherAreas}
            setVolume={this.setAvailableVolume}
          />
          <CalculatorInput
            label="Počet obyvatel (pokud chcete využívat vodu i na splachování WC), není nutné zadávat"
            paramId={"dwellersCount"}
            value={this.state.dwellersCount}
            onChangeHandler={this.inputChanged}
            onBlurHandler={this.inputBlurred}
            touched={this.state.touched.dwellersCount}
            errorClass={this.state.dwellersCountValid}
            errorText={"Nastave počet trvale žijících obytel (může být i 0)"}
            valid={this.state.dwellersCountValid}
            placeholder={"Vyplňte počet trvale žijících osob..."}
          />
          <CalculatorInput
            label="Plocha zahrady pro zálivku (m²)"
            paramId={"gardenArea"}
            value={this.state.gardenArea}
            onChangeHandler={this.inputChanged}
            onBlurHandler={this.inputBlurred}
            touched={this.state.touched.gardenArea}
            errorClass={this.state.gardenAreaValid}
            errorText={"Nastavte plochu zahrady pro zálivku (může být i 0)"}
            valid={this.state.gardenAreaValid}
            placeholder={"Vyplňte plochu zahrady..."}
          />
          <NeededVolume
            valid={this.state.dwellersCountValid && this.state.gardenAreaValid}
            dwellersCount={this.state.dwellersCount}
            gardenArea={this.state.gardenArea}
            setVolume={this.setNeededVolume}
          />
          <CalcSummary
            valid={(this.state.touched.gardenArea || this.state.touched.dwellersCount) && this.state.touched.rainVolume && this.availableVolume && this.neededVolume}
            waterNeeded={this.neededVolume}
            waterAvailable={this.availableVolume}
          />
          {/* <div className="form-group calculator--text-center">
              <button
                className="btn btn-block btn-lg mt"
                onClick={this.calculateButton}
                disabled={!this.state.formValid}
              >
                Výpočet
              </button>
          </div> */}
        </div>

        {/* <CalculatorResults
          data={this.state.calculationResults}
          valid={this.state.formValid}
        /> */}

        {this.state.formErrorMessage &&
        <p style={{ color: "red", padding: "0 15px", textAlign: 'center'}}>
          {this.state.formErrorMessage}
        </p>}

        <div /*className="album py-5 bg-white"*/>
          <SuggestedProducts
            tanksAbove={this.suggestedTanksAboveGround}
            tanksUnder={this.suggestedTanksUnderGround}
            sets={this.suggestedSets} />
          {/*<ContactForm showForm={!!this.state.suggestedTanksAboveGround.length || !!this.state.suggestedTanksUnderGround.length ||
          !!this.state.suggestedSets.length}/>*/}
        </div>
        <div id="result"/>
      </div>
    );
  }
}

export default App;
